// Blue
export const BlueBase = '#2D9CDB';
export const BlueDark = '#2179CA';
export const BlueDarkX = '#07163E';
export const BlueLight = '#536DFE';
export const BlueLight1 = '#EAF3FB';
export const BlueLightDark = '#334fe8';
export const BlueDE = '#DFEEA4';
export const Blue25 = '#254562';
export const BlueE9 = '#E9F2FA';
export const Blue13 = '#132E74';

// Violet
export const Violet = '#6A4EF6';

// White
export const White = '#ffffff';

// Black
export const Black = '#000000';
export const Grey = '#233B58';
export const GreyAB = '#ABB8C3';
export const Grey8c = '#8C8C8C';
export const Grey8 = '#888888';
export const Grey7 = '#777777';
export const Grey3 = '#333333';
export const GreyA2 = '#A2ABC1';
export const GreyA0 = '#A0B1BF';
export const GreyCE = '#cecece';
export const GreyC4 = '#C4C4C4';
export const GreyE1 = '#E1E7EC';
export const GreyEC = '#ececec';
export const Grey6 = '#666666';
export const Grey69 = '#696969';
export const Grey87 = '#8792af';
export const Grey8A = '#8A97BA';
export const Grey58 = '#58728C';
export const GreyF5 = '#F5FAFD';
export const GreyF6 = '#F6FAFD';
export const GreyF9 = '#f9f9f9';
export const Grey6A = '#6a6c6f';
export const GreyEB = '#ebeffb';
export const Grey53 = '#53627C';

// Grey
export const Grey100 = '#f5f5f5';
export const Grey400 = '#4898ED';

// Red
export const Red = '#CD0000';
export const Red1 = '#EF6868';

// Yellow
export const Yellow = '#ff8100';
export const YellowDark = '#FFB059';

// Green
export const GreenBase = '#28a745';
export const GreenDark = '#218838';
export const Green1 = '#60CC17';

// Textbox
export const BorderColorTB = '#C9CED8';
export const ShadowColorTB = '#cad9ff';

// Scrollbar
export const ScrollbarColor = '#C4C4C4';

// Placeholder
export const PlaceholderColor = '#B5B5B5';

// Border
export const Border1 = '#8ba3e2';
export const Border2 = '#e5e7e9';

export const colors = {
	GreyAB,
	GreyEB,
	Grey53,
	Blue25,
	BlueDE,
	BlueBase,
	BlueDark,
	BlueDarkX,
	BlueLight,
	BlueLight1,
	BlueLightDark,
	BlueE9,
	Blue13,
	White,
	Red,
	Red1,
	Yellow,
	YellowDark,
	Violet,
	Black,
	Grey,
	Grey100,
	Grey400,
	Grey8c,
	Grey8,
	Grey3,
	Grey7,
	GreyA2,
	GreyA0,
	Grey6,
	GreyE1,
	Grey69,
	Grey87,
	GreyEC,
	GreyCE,
	GreyC4,
	Grey8A,
	GreyF5,
	GreyF6,
	GreyF9,
	Grey6A,
	BorderColorTB,
	ShadowColorTB,
	Border1,
	Border2,
	GreenBase,
	GreenDark,
	Grey58,
	Green1,
	ScrollbarColor,
	PlaceholderColor,
};
